module.exports = __webpack_public_path__ + "static/img/order-detail-gif2.b5d695c2.gif";